import { render, staticRenderFns } from "./Index-ventas.vue?vue&type=template&id=50a075a4"
import script from "./Index-ventas.vue?vue&type=script&lang=js"
export * from "./Index-ventas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports